import { SlideInPortalId } from '../../account/root/components/PortalSlidein';
import { ReactNode, useState, useEffect } from 'react';
import { createPortal } from 'react-dom';

interface ModalProps {
    portal: SlideInPortalId;
    children: ReactNode;
}

/*
this modal renders checks itself when the target appears in the dom
and mount's itself. this is necessary if the modal must render on the
first render of the dom tree (for example spinner)
*/
export function Modal(props: ModalProps) {
    const [rootPresent, setRootPresent] = useState(
        () => document.getElementById(props.portal) != null,
    );

    // Poll until the portal target appears, as the class did from its
    // constructor. `rootPresent` only exists to trigger the re-render that then
    // finds the element - the node itself is looked up during render, so a
    // portal root that its route unmounts and remounts is still picked up. The
    // cleanup also stops the poll on unmount, which the class never did.
    useEffect(() => {
        if (rootPresent) {
            return;
        }
        let timeoutId: ReturnType<typeof setTimeout>;
        const checkForElement = () => {
            if (document.getElementById(props.portal) == null) {
                timeoutId = setTimeout(checkForElement, 8);
            } else {
                setRootPresent(true);
            }
        };
        checkForElement();
        return () => clearTimeout(timeoutId);
    }, [props.portal, rootPresent]);

    const portalRoot = document.getElementById(props.portal);
    return portalRoot ? createPortal(props.children, portalRoot) : null;
}
